import '../style/learnmore.css'

function Learnmore() {
    return (
        <section className="learnmore">
            <h1 className="learnmore-title">Learn More At</h1>
            <a href="https://www.instagram.com/sweetsips.absis17/" className="learnmore-ig">instagram.com/sweetsips.absis17</a>
        </section>
    );
}

export default Learnmore;